<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Master Data" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Jadwal',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Megubah Jadwal',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <!-- <form> -->
          <div class="profile-intro" v-if="nama && unit">
            <img class="profile-img" :src="'/img/user.jpg'" />
            <div class="profile-info">
              <h3>{{ nama }}</h3>
              <h5>{{ kode }}</h5>
              <h4>{{ unit.nama }}</h4>
            </div>
          </div>
          <div class="page-content-title mb-2">
            <div class="left">
              <div>
                <h4 class="title mb-0">Ubah Jadwal Praktek</h4>
              </div>
            </div>
          </div>
          <div>
            <!-- <datatable v-if="loaded && rows.length"
                :columns="columns"
                :per-page="parseInt(perPage)"
                :data="rows"
                :filter="filter"
                class="table table-hover responsive"
                ></datatable> -->
            <div v-if="loaded && rows.length" class="row">
              <div
                class="col-md-4"
                style="position:relative"
                v-for="(item, hari) in rows"
                v-bind:key="item.hari"
              >
                <h4 class="mt-4 mb-3">
                  {{ item.hari }}
                  <button
                    class="btn btn-with-icon-left btn-outline-secondary btn-sm float-right"
                    @click="() => addItem(hari, '', '')"
                  >
                    <i class="material-symbols-outlined">add</i> Jadwal
                  </button>
                </h4>
                <table class="responsive" v-if="item.jadwal.length">
                  <thead>
                    <th>Jam Mulai</th>
                    <th>Jam Selesai</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(jd, index) in item.jadwal.filter(
                        (item) => !item.deleted
                      )"
                      v-bind:key="jd.id"
                    >
                      <td>
                        <InputTime
                          @handleChange="
                            (e) => handleChange(e, 'jam_mulai', hari, index)
                          "
                          :value="jd.jam_mulai"
                          :input="{ class: '', name: 'jam_mulai-' + index }"
                        />
                        <small
                          v-if="jd.errorMulai"
                          class="form-text text-danger mb-0 small"
                        >
                          {{ jd.errorMulai }}
                        </small>
                      </td>
                      <td>
                        <InputTime
                          @handleChange="
                            (e) => handleChange(e, 'jam_selesai', hari, index)
                          "
                          :value="jd.jam_selesai"
                          :input="{ class: '', name: 'jam_selesai-' + index }"
                        />
                        <small
                          v-if="jd.errorSelesai"
                          class="form-text text-danger mb-0 small"
                        >
                          {{ jd.errorSelesai }}
                        </small>
                      </td>
                      <td>
                        <button
                          class="btn btn-icon btn-outline-danger btn-sm"
                          @click="() => deleteItem(hari, index)"
                        >
                          <i class="material-symbols-outlined">delete</i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <EmptyState
              v-else-if="loaded && !rows.length"
              :data="{ size: 'small' }"
            />
            <Loading v-else />
            <div class="card p-3 my-5">
              <div class="row">
                <div class="col-md-12">
                  <button
                    @click="handleForm"
                    class="btn btn-primary btn-with-icon-left float-right text-uppercase ml-3 text-uppercase"
                  >
                    <i class="material-symbols-outlined">check_circle</i>
                    Simpan jadwal
                  </button>
                  <!-- <router-link
                        class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                        to="/ralan"
                      >Batalkan</router-link> -->
                  <a
                    class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                    @click="() => goBack('/master/dokter')"
                    >Batalkan
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import InputTime from "@/components/InputTime.vue";
import Alert from "@/components/Alert.vue";
// import FormGroup from "@/components/FormGroup.vue";
// import { HTTP,HTTP_ENC } from "@/config.js";

let days = {
  Senin: 1,
  Selasa: 2,
  Rabu: 3,
  Kamis: 4,
  Jumat: 5,
  Sabtu: 6,
  Minggu: 7,
};

let emptySchedule = [
  { hari: "Senin", jadwal: [] },
  { hari: "Selasa", jadwal: [] },
  { hari: "Rabu", jadwal: [] },
  { hari: "Kamis", jadwal: [] },
  { hari: "Jumat", jadwal: [] },
  { hari: "Sabtu", jadwal: [] },
  { hari: "Minggu", jadwal: [] },
];

export default {
  name: "DokterJadwal",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    Loading,
    EmptyState,
    InputTime,
    Alert,
    // FormGroup
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      saveFailed: false,
      saveSuccess: false,
      isError: false,
      data: {
        title: "Ubah Jadwal Dokter",
        backBtn: ``,
        actionBtn: [],
        breadcrumb: [
          { title: "Dokter", link: `` },
          { title: "Ubah Jadwal Dokter", active: true },
        ],
      },
      id_unit: null,
      kode: null,
      nama: "",
      unit: null,
      s_jadwal: "",
      jadwal: [],
      deleteSuccess: false,
      deleteFailed: false,
      loaded: false,
      columns: [
        {
          label: "Hari",
          field: "hari",
          headerClass: "class-in-header second-class",
          sortable: false,
        },
        {
          label: "Jadwal",
          class: "dropdown",
          sortable: false,
          representedAs: (row) => {
            let schedules = "";
            if (row.jadwal.length) {
              row.jadwal.forEach((item) => {
                schedules += `<span class="badge badge-primary badge-sm mr-2 my-1" style="display:inline-block;">${item.jam_mulai} - ${item.jam_selesai}</span>`;
              });
            } else {
              schedules += `<span class="badge badge-danger badge-sm mr-2 my-1" style="display:inline-block;">Tidak ada jadwal</span>`;
            }

            return `${schedules}`;
          },
          interpolate: true,
        },
        {
          label: "",
          class: "dropdown",
          interpolate: true,
        },
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      rows: [],
      id_dokter: null,
    };
  },
  methods: {
    goBack(url) {
      if (window.history.length <= 1) {
        this.$router.push({ path: url });
      } else {
        this.$router.go(-1);
      }
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `dokter/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.id_unit = result.data.id_unit;
          this.kode = result.data.kode;
          this.nama = result.data.nama;
          this.getUnit();
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },

    getUnit: async function() {
      try {
        let result = await this.$store.state.HTTP.get(`unit/${this.id_unit}`);
        if (result.status == "200") {
          this.unit = result.data;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    resetAlert() {
      let self = this;
      setTimeout(function() {
        self.deleteSuccess = false;
        self.deleteFailed = false;
      }, 5000);
    },
    async filterTab(filter) {
      //console.log(filter);
      this["id_dokter"] = filter;
      await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
    },
    handleForm: async function() {
      let self = this;
      //console.log(this.rows);
      self.errors = [];
      let valid = this.validateForm();
      // let valid=true;
      if (valid) {
        //console.log(valid);
        for (const hari of this.rows) {
          for (const jadwal of hari.jadwal) {
            let result;
            if (jadwal.id) {
              if (jadwal.deleted) {
                result = await this.$store.state.HTTP.delete(
                  `dokter/jadwal/harian/${jadwal.id}`
                );
              } else {
                result = await this.$store.state.HTTP.put(
                  `dokter/jadwal/harian/${jadwal.id}`,
                  `jam_mulai=${jadwal.jam_mulai}&jam_selesai=${jadwal.jam_selesai}`
                );
              }
            } else {
              result = await this.$store.state.HTTP.post(
                `dokter/jadwal/harian`,
                `hari=${hari.hari}&id_dokter=${jadwal.id_dokter}&jam_mulai=${jadwal.jam_mulai}&jam_selesai=${jadwal.jam_selesai}`
              );
            }
            if (result) {
              //console.log(result);
            } else {
              this.saveFailed = true;
            }
          }
        }
        self.checkSuccess();
      } else {
        //console.log(valid);
      }
    },
    checkSuccess() {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
          that.$router.push(`/master/dokter/detail/${that.$route.params.id}`);
        }, 500);
      }
    },
    handleChange(e, column, hari, index) {
      //console.log(e.target.value);
      //console.log(e,this.rows);
      this.rows[hari].jadwal[index][column] = e.target.value;
    },
    validateForm: function() {
      let valid = true;
      this.rows = this.rows.map((item) => {
        item.jadwal = item.jadwal.map((jdw) => {
          if (jdw["jam_mulai"] && jdw["jam_selesai"]) {
            if (jdw["jam_mulai"] >= jdw["jam_selesai"]) {
              jdw["errorMulai"] = "Jam mulai harus";
              jdw["errorSelesai"] = "< dari jam selesai";
              valid = false;
            } else {
              jdw["errorMulai"] = "";
              jdw["errorSelesai"] = "";
            }
          } else {
            if (!jdw["jam_mulai"] && !jdw["jam_selesai"]) {
              jdw["errorMulai"] = "Wajib diisi";
              jdw["errorSelesai"] = "Wajib diisi";
            } else if (!jdw["jam_mulai"]) {
              jdw["errorMulai"] = "Wajib diisi";
              jdw["errorSelesai"] = "";
            } else if (!jdw["jam_selesai"]) {
              jdw["errorSelesai"] = "Wajib diisi";
              jdw["errorMulai"] = "";
            }
            valid = false;
          }
          return jdw;
        });
        return item;
      });
      return valid;
    },
    addItem: async function(index, jam_mulai, jam_selesai) {
      this.rows[index].jadwal = this.rows[index].jadwal.concat({
        jam_mulai,
        jam_selesai,
        id_dokter: this.$route.params.id,
      });
    },
    deleteItem: async function(hari, index) {
      let jadwal = this.rows[hari].jadwal[index];
      if (jadwal) {
        if (jadwal.id) {
          this.rows = this.rows.map((item, hariNya) => {
            if (hariNya == hari) {
              item.jadwal = item.jadwal.map((jd, idx) => {
                if (index == idx) {
                  jd.deleted = true;
                }
                return jd;
              });
            }
            return item;
          });
        } else {
          this.rows = this.rows.map((item, hariNya) => {
            if (hariNya == hari) {
              item.jadwal = item.jadwal.filter((jd, idx) => {
                //console.log(jd);
                return index != idx;
              });
            }
            return item;
          });
        }
      }
    },
    displayList: async function() {
      this.loaded = false;
      this.errors = [];
      let params = `?per_page=999999999999&orderBy=asc&id_dokter=${this.id_dokter}`;
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter/jadwal/harian" + params
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log("berhasil");
          let schedules = result.data.data;
          //console.log(schedules);
          let self = this;
          this.rows = emptySchedule;
          schedules.forEach((item) => {
            if (self.rows.length) {
              let index = -1;
              let found = self.rows.find((row, i) => {
                if (item.hari == row.hari) {
                  index = i;
                }
                return item.hari == row.hari;
              });
              if (found && index > -1) {
                // found.jadwal=found.jadwal.concat({jam_mulai:item.jam_mulai,jam_selesai:item.jam_selesai});
                self.rows[index].jadwal = self.rows[index].jadwal.concat({
                  jam_mulai: item.jam_mulai,
                  jam_selesai: item.jam_selesai,
                  id: item.id,
                  id_dokter: self.$route.params.id,
                });
              } else {
                self.rows = self.rows.concat({
                  no: days[item.hari],
                  hari: item.hari,
                  jadwal: [
                    {
                      jam_mulai: item.jam_mulai,
                      jam_selesai: item.jam_selesai,
                      id: item.id,
                      id_dokter: self.$route.params.id,
                    },
                  ],
                });
              }
            } else {
              self.rows = self.rows.concat({
                no: days[item.hari],
                hari: item.hari,
                jadwal: [
                  {
                    jam_mulai: item.jam_mulai,
                    jam_selesai: item.jam_selesai,
                    id: item.id,
                    id_dokter: self.$route.params.id,
                  },
                ],
              });
            }
          });
          this.loaded = true;
          // this.rows=this.rows.sort((a,b) => (a.no > b.no) ? 1 : ((b.no > a.no) ? -1 : 0));
          //console.log(this.rows);
          //console.log(this.rows);
          self.rows = self.rows.map((item) => {
            if (!item.jadwal.length) {
              item.jadwal = [
                {
                  jam_mulai: "",
                  jam_selesai: "",
                  id: null,
                  id_dokter: self.$route.params.id,
                },
              ];
            }
            return item;
          });
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.data.backBtn = `/master/dokter/detail/${this.$route.params.id}`;
    this.data.breadcrumb[0].link = this.data.backBtn;
    this.id_dokter = this.$route.params.id;
    this.displayData();
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
  },
};
</script>
